<template>
  <v-img :src="src" height="800" gradient="to top right, rgba(0,0,0,.8), rgba(25,32,72,.7)">
    <v-container>
      <br />
      <br />
      <!-- Titulo -->
      <h1
        class="display-1 font-weight-bold text-center pa-4 white--text"
        v-text="$t('contacto[0]')"
      ></h1>
      <!-- Fin Titulo -->
      <form class="pb-10" id="myform">
        <v-select
          v-model="select"
          :items="$t('contacto[2]')"
          :error-messages="selectErrors"
          :label="$t('contacto[1]')"
          color="white"
          dark
          required
          @change="$v.select.$touch()"
          @blur="$v.select.$touch()"
        ></v-select>
        <v-text-field
          v-model="name"
          :error-messages="nameErrors"
          :counter="30"
          :label="$t('contacto[3]')"
          required
          color="white"
          dark
          @input="$v.name.$touch()"
          @blur="$v.name.$touch()"
        ></v-text-field>
        <v-text-field
          v-model="email"
          :error-messages="emailErrors"
          :label="$t('contacto[4]')"
          required
          color="white"
          dark
          @input="$v.email.$touch()"
          @blur="$v.email.$touch()"
        ></v-text-field>
        <v-autocomplete
          v-model="country"
          :items="Countries"
          :error-messages="selectErrors"
          :label="$t('contacto[5]')"
          required
          dark
          color="white"
          @change="$v.select.$touch()"
          @blur="$v.select.$touch()"
        ></v-autocomplete>
        <v-text-field
          v-model="subject"
          :error-messages="subjectErrors"
          :counter="30"
          :label="$t('contacto[6]')"
          required
          dark
          @input="$v.subject.$touch()"
          @blur="$v.subject.$touch()"
        ></v-text-field>
        <v-textarea
          class="pt-6"
          outlined
          :error-messages="messageErrors"
          :counter="200"
          dark
          @input="$v.message.$touch()"
          @blur="$v.message.$touch()"
          v-model="message"
          :label="$t('contacto[7]')"
          value="The Woodman set to work at once, and so sharp was his axe that the tree was soon chopped nearly through."
        ></v-textarea>
        <br />
        <v-btn class="mr-4 success" @click="enviar()" v-text="$t('contacto[8]')" id="btnEnvio"></v-btn>
        <v-btn @click="clear" v-text="$t('contacto[9]')"></v-btn>
      </form>
    </v-container>
  </v-img>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";

export default {
  methods: {
    submit() {
      this.$refs.observer.validate();
    },
    clear() {
      this.select = null;
      this.country = null;
      this.name = "";
      this.email = "";
      this.subject = "";
      this.message = "";
    },
    enviar() {
      let data = {
        nombre_usuario: this.name,
        entidad_usuario: this.select,
        email_usuario: this.email,
        pais_usuario: this.country,
        subject_usuario: this.subject,
        mensaje_usuario: this.message
      };

      emailjs.send("gmail", "evascopes_correo", data).then(
        function(response) {
          if (response.text === "OK") {
            alert("Tu Solicitud ha sido enviada con exito! Te contactaremos a la brevedad. Gracias por preferir Evascopes junto a sus mejores telescopios de astrofotografia del mundo");
          }
          console.log(
            "SUCCESS. status=%d, text=%s",
            response.status,
            response.text
          );
        },
        function(err) {
          alert("Ocurrió un problema al enviar el correo");
          console.log("FAILED. error=", err);
        }
      );
    }
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      !this.$v.name.maxLength &&
        errors.push("Name must be at most 30 characters long");
      !this.$v.name.required && errors.push("Name is required.");
      return errors;
    },
    subjectErrors() {
      const errors = [];
      if (!this.$v.subject.$dirty) return errors;
      !this.$v.subject.maxLength &&
        errors.push("Subject must be at most 30 characters long");
      !this.$v.subject.required && errors.push("Subject is required.");
      return errors;
    },
    messageErrors() {
      const errors = [];
      if (!this.$v.message.$dirty) return errors;
      !this.$v.message.maxLength &&
        errors.push("message must be at most 200 characters long");
      !this.$v.message.required && errors.push("Message is required.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid e-mail");
      !this.$v.email.required && errors.push("E-mail is required");
      return errors;
    }
  },
  mixins: [validationMixin],
  validations: {
    name: { required, maxLength: maxLength(30) },
    email: { required, email },
    select: { required },
    subject: { required, maxLength: maxLength(30) },
    message: { required, maxLength: maxLength(200) },
    country: { required }
  },
  props: ["contacto"],
  data() {
    return {
      name: "",
      email: "",
      subject: "",
      message: "",

      src: require("../assets/Pangue.jpg"),

      Countries: [
        "Afghanistan",
        "Albania",

        "Algeria",

        "Andorra",

        "Angola",

        "Antigua and Barbuda",

        "Argentina",

        "Armenia",

        "Aruba",

        "Australia",
        "Austria",

        "Azerbaijan",

        "Bahamas, The",

        "Bahrain",

        "Bangladesh",

        "Barbados",

        "Belarus",

        "Belgium",

        "Belize",

        "Benin",

        "Bhutan",

        "Bolivia",

        "Bosnia and Herzegovina",

        "Botswana",

        "Brazil",

        "Brunei",

        "Bulgaria",

        "Burkina Faso",

        "Burma",

        "Burundi",

        "Cambodia",

        "Cameroon",

        "Canada",

        "Cape Verde",

        "Central African Republic",

        "Chad",

        "Chile",

        "China",

        "Colombia",

        "Comoros",

        "Congo, Democratic Republic of the",

        "Congo, Republic of the",

        "Costa Rica",

        "Cote d'Ivoire",

        "Croatia",

        "Cuba",

        "Curacao",

        "Cyprus",

        "Czech Republic",

        "Denmark",

        "Djibouti",

        "Dominica",

        "Dominican Republic",

        "East Timor (see Timor-Leste)",

        "Ecuador",

        "Egypt",

        "El Salvador",

        "Equatorial Guinea",

        "Eritrea",

        "Estonia",

        "Ethiopia",

        "Fiji",

        "Finland",

        "France",

        "Gabon",

        "Gambia, The",

        "Georgia",

        "Germany",

        "Ghana",

        "Greece",

        "Grenada",

        "Guatemala",

        "Guinea",

        "Guinea-Bissau",

        "Guyana",

        "Haiti",

        "Holy See",

        "Honduras",

        "Hong Kong",

        "Hungary",

        "Iceland",

        "India",

        "Indonesia",

        "Iran",

        "Iraq",

        "Ireland",

        "Israel",

        "Italy",

        "Jamaica",

        "Japan",

        "Jordan",

        "Kazakhstan",

        "Kenya",

        "Kiribati",

        "Korea, North",

        "Korea, South",

        "Kosovo",

        "Kuwait",

        "Kyrgyzstan",

        "Laos",

        "Latvia",

        "Lebanon",

        "Lesotho",

        "Liberia",

        "Libya",

        "Liechtenstein",

        "Lithuania",

        "Luxembourg",

        "Macau",

        "Macedonia",

        "Madagascar",

        "Malawi",

        "Malaysia",

        "Maldives",

        "Mali",

        "Malta",

        "Marshall Islands",

        "Mauritania",

        "Mauritius",

        "Mexico",

        "Micronesia",

        "Moldova",

        "Monaco",

        "Mongolia",

        "Montenegro",

        "Morocco",

        "Mozambique",

        "Namibia",

        "Nauru",

        "Nepal",

        "Netherlands",

        "Netherlands Antilles",

        "New Zealand",

        "Nicaragua",

        "Niger",

        "Nigeria",

        "North Korea",

        "Norway",

        "Oman",

        "Pakistan",

        "Palau",

        "Palestinian Territories",

        "Panama",

        "Papua New Guinea",

        "Paraguay",

        "Peru",

        "Philippines",

        "Poland",

        "Portugal",

        "Qatar",

        "Romania",

        "Russia",

        "Rwanda",

        "Saint Kitts and Nevis",

        "Saint Lucia",

        "Saint Vincent and the Grenadines",

        "Samoa",

        "San Marino",

        "Sao Tome and Principe",

        "Saudi Arabia",

        "Senegal",

        "Serbia",

        "Seychelles",

        "Sierra Leone",

        "Singapore",

        "Sint Maarten",

        "Slovakia",

        "Slovenia",

        "Solomon Islands",

        "Somalia",

        "South Africa",

        "South Korea",

        "South Sudan",

        "Spain",

        "Sri Lanka",

        "Sudan",

        "Suriname",

        "Swaziland",

        "Sweden",

        "Switzerland",

        "Syria",

        "Taiwan",

        "Tajikistan",

        "Tanzania",

        "Thailand",

        "Timor-Leste",

        "Togo",

        "Tonga",

        "Trinidad and Tobago",

        "Tunisia",

        "Turkey",

        "Turkmenistan",

        "Tuvalu",

        "Uganda",

        "Ukraineom",

        "United States of America",

        "Uruguay",

        "Uzbekistan",

        "Vanuatu",

        "Venezuela",

        "Vietnam",

        "Yemen",

        "Zambia",

        "Zimbabwe"
      ],
      entidades: [
        "Natural Person",
        "Educational Institution",
        "Company",
        "StartUp",
        "NonProfit Organization"
      ]
    };
  }
};
</script>